module.exports = __webpack_public_path__ + "img/new-barcode-icon-white.ce4f37a0.svg";